/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WHEN_MAKING_CHANGES_TO_CONTRACTS_THE_FACILITY_DOES_NOT_SEEK_THE',
              'SIGNED_COPIES_OF_CONTRACTS_BETWEEN_THE_FACILITY_AND_EACH_WORKER',
              'CONTRACTS_DO_NOT_CLEARLY_AND_ACCURATELY_STATE_THE_TERMS_AND_CON',
              'COPIES_OF_CONTRACTS_ARE_NOT_PROVIDED_TO_WORKERS_IN_LINE_WITH_AP',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_follow_any_of_the_following_practices_related_to_c: valueSchema,
  },
}
